import type { Editor, NodeEntry } from 'slate';
import { Node, Transforms } from 'slate';

import type { TOCElement } from '../../internal';
import { isAlineContentBlock } from '../../internal';

export function normalizeTOC(editor: Editor, tocEntry: NodeEntry<TOCElement>): void {
  const [toc, tocPath] = tocEntry;
  let hasAtLeastOneContentBlock = false;

  for (const [child, childPath] of Node.children(toc, [], { reverse: true })) {
    if (isAlineContentBlock(child)) {
      hasAtLeastOneContentBlock = true;
    } else {
      Transforms.removeNodes(editor, { at: [...tocPath, ...childPath] });
    }
  }

  if (!hasAtLeastOneContentBlock) return Transforms.removeNodes(editor, { at: tocPath });

  if (!Array.isArray(toc.suggestedEdits)) {
    Transforms.setNodes(editor, { suggestedEdits: [] }, { at: tocPath });
  }
}
